import React, { MouseEvent } from 'react';
import { Paper } from '../../../../../../ui';
import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import { SaveCreditCard } from './SaveCreditCard';
import { CancelNewCard } from './CancelNewCard';
import { CreditCardForm } from '../../../../../payment/ui/credit-card/form';
import { useStores } from '../../../../../app/root/domain/stores/useStores';
import { useFlexMicroform } from '../../../../../payment/ui/credit-card/form/helpers/useFlexMicroform';
import { PaymentMainUserShimmer } from '../PaymentMainUserShimmer';
import { ErrorMessage } from './ErrorMessage';

interface INewCardProps {
	onClickCancel?: (e: MouseEvent) => void;
	canBeSaved?: boolean;
	canBeCanceled?: boolean;
}

export const NewCard = observer(
	({ canBeSaved, canBeCanceled, onClickCancel }: INewCardProps) => {
		const { captureContextStore } = useStores();
		const { microform, error } = useFlexMicroform(captureContextStore);

		if (!microform) {
			return <PaymentMainUserShimmer />;
		}

		if (error) {
			return <ErrorMessage />;
		}

		return (
			<Paper data-testid="new-card-form">
				<CreditCardForm />

				<BottomRow>
					{canBeSaved && <SaveCreditCard defaultChecked />}
					{canBeCanceled && <CancelNewCard onClick={onClickCancel} />}
				</BottomRow>
			</Paper>
		);
	},
);

const BottomRow = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: 0;
`;
